import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, className = "" }) => (
  <Reveal className={className}>
    <p className="font-mono-brand text-xs md:text-sm tracking-[0.3em] text-electric mb-4">{eyebrow}</p>
    <h2 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white">{title}</h2>
  </Reveal>
);
